import { Point, PointLike } from "mapbox-gl";

export const screenPointToArea = (point: Point): [PointLike, PointLike] => {
  const bottomLeft = new Point(point.x - 10, point.y + 10);
  const topRight = new Point(point.x + 10, point.y - 10);
  return [bottomLeft, topRight];
};
